// Connect 4 Battle Client
import { sounds } from '../sound.js';

export class Connect4Client {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.board = Array(6).fill(null).map(() => Array(7).fill(0));
    this.currentTurn = 1;
    this.player1 = null;
    this.player2 = null;

    this.render();
    this.setupSocketEvents();
  }

  render() {
    this.container.innerHTML = `
      <div class="c4-wrapper">
        <div class="c4-header">
          <h2>🔴 CONNECT 4 BATTLE</h2>
          <div id="c4-turn-status" class="c4-badge">Turn: Player 1 (Red)</div>
        </div>

        <div class="c4-players-bar">
          <div class="c4-player p1 active" id="c4-p1-card">
            <span class="c4-chip red"></span>
            <span id="c4-p1-name">Player 1</span>
          </div>
          <div class="c4-vs">VS</div>
          <div class="c4-player p2" id="c4-p2-card">
            <span class="c4-chip yellow"></span>
            <span id="c4-p2-name">Player 2</span>
          </div>
        </div>

        <!-- Board -->
        <div class="c4-board-container">
          <div class="c4-columns-trigger" id="c4-triggers">
            ${[0, 1, 2, 3, 4, 5, 6].map(c => `
              <div class="c4-col-drop" data-col="${c}">▼</div>
            `).join('')}
          </div>

          <div class="c4-grid" id="c4-grid">
            <!-- 42 slots -->
          </div>
        </div>
      </div>
    `;

    this.buildGrid();
    this.setupTriggers();
  }

  buildGrid() {
    const grid = document.getElementById('c4-grid');
    if (!grid) return;
    grid.innerHTML = '';
    for (let r = 0; r < 6; r++) {
      for (let c = 0; c < 7; c++) {
        const slot = document.createElement('div');
        slot.className = 'c4-slot';
        slot.dataset.row = r;
        slot.dataset.col = c;
        const val = this.board[r][c];
        if (val === 1) slot.classList.add('red');
        if (val === 2) slot.classList.add('yellow');
        grid.appendChild(slot);
      }
    }
  }

  setupTriggers() {
    document.querySelectorAll('.c4-col-drop').forEach((btn) => {
      btn.addEventListener('click', () => {
        const col = parseInt(btn.dataset.col);
        this.socket.emit('c4_drop', { column: col });
      });
    });
  }

  setupSocketEvents() {
    this.socket.on('c4_started', (data) => {
      this.player1 = data.player1;
      this.player2 = data.player2;
      this.board = data.board;
      this.currentTurn = data.currentTurn;

      const p1Name = document.getElementById('c4-p1-name');
      const p2Name = document.getElementById('c4-p2-name');
      if (p1Name) p1Name.innerText = this.player1?.name || 'Player 1';
      if (p2Name) p2Name.innerText = this.player2?.name || 'Player 2';

      this.buildGrid();
      this.updateTurnUI();
    });

    this.socket.on('c4_pieceDropped', (data) => {
      sounds.playPop();
      this.board = data.board;
      this.currentTurn = data.currentTurn;
      this.buildGrid();
      this.updateTurnUI();
    });

    this.socket.on('c4_gameOver', (data) => {
      sounds.playVictory();
      const status = document.getElementById('c4-turn-status');
      if (status) {
        status.innerText = data.winner ? `🏆 WINNER: ${data.winner.name}!` : '🤝 DRAW!';
        status.style.color = '#fbbf24';
      }
    });
  }

  updateTurnUI() {
    const status = document.getElementById('c4-turn-status');
    const p1Card = document.getElementById('c4-p1-card');
    const p2Card = document.getElementById('c4-p2-card');

    if (this.currentTurn === 1) {
      if (status) status.innerText = `Turn: ${this.player1?.name || 'Player 1'} (Red)`;
      p1Card?.classList.add('active');
      p2Card?.classList.remove('active');
    } else {
      if (status) status.innerText = `Turn: ${this.player2?.name || 'Player 2'} (Yellow)`;
      p2Card?.classList.add('active');
      p1Card?.classList.remove('active');
    }
  }

  destroy() {
    this.socket.off('c4_started');
    this.socket.off('c4_pieceDropped');
    this.socket.off('c4_gameOver');
  }
}
